import List from '@mui/material/List';
import {
    SortableContext,
    verticalListSortingStrategy,
} from '@dnd-kit/sortable';
import DraggableItem from "./DraggableItem";

const Droppable = (props) => {
    return <>
        <SortableContext
            items={props.items}
            strategy={verticalListSortingStrategy}
        >
            <List>
                {props.items.map(item => <DraggableItem key={item.id} id={item.id} item={item} collapsed={props.collapsed} action={item.action} />)}
            </List>
        </SortableContext>
    </>
};

export default Droppable;